import * as React from 'react';
import { Popover, Upload } from 'antd';
import { UploadProps } from 'antd/lib/upload';
import { PopoverProps } from 'antd/lib/popover';
import { NiButton } from '@component/ant-component/button';

export type NiUploadProps = UploadProps & {
  popOver?: PopoverProps;
  buttonText: string;
};

export type NiUploadState = {};
export class NiUpload extends React.Component<NiUploadProps, NiUploadState> {
  render() {
    return (
      <Upload {...this.props}>
        {this.props.popOver ? (
          <Popover {...this.props.popOver}>
            <NiButton key="upload-btn" type="primary">
              <span>{this.props.buttonText}</span>
            </NiButton>
          </Popover>
        ) : (
          <NiButton suppressHydrationWarning key="upload-btn" type="primary">
            <span>{this.props.buttonText}</span>
          </NiButton>
        )}
      </Upload>
    );
  }
}
